module.exports = __webpack_public_path__ + "img/BrokenImage.c2497f9a.svg";